import axios from "axios";

export const expiredTokenHandler = async (response) => {
  const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
  const result = await axios.post(`${apiPreUrl}/api/auth/token`, {}, { withCredentials: true });
  sessionStorage.setItem("AccessToken", result.data.access_token);
  response.config.headers.Authorization = `Bearer ${result.data.access_token}`;

  return axios(response.config);
  // try {
  //   const result = await axios.post(`${apiPreUrl}/api/auth/token`, {}, { withCredentials: true });
  //   sessionStorage.setItem("AccessToken", result.data.access_token);
  //   response.config.headers.Authorization = `Bearer ${result.data.access_token}`;

  //   //location.reload();
  //   return axios(response.config);
  // } catch (error) {
  //   sessionStorage.removeItem("AccessToken"); 
  //   location.href = '/'; 
  //   return Promise.reject(error);
  // }
}